var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElementsDesktopBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250,
    height: 66,
    viewBox: "0 0 250 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wr3r9zpgoa",
    x1: "52.11%",
    x2: "52.11%",
    y1: "22.044%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.322%",
    stopColor: "#FFF",
    stopOpacity: 0.931
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("rect", {
    id: "9lp07qwvsb",
    width: 250,
    height: 66,
    x: 0,
    y: 0,
    rx: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 66,
    fill: "#FFF",
    fillOpacity: 0,
    rx: 32,
    transform: "matrix(1 0 0 -1 0 66)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    transform: "matrix(1 0 0 -1 0 66)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#wr3r9zpgoa)",
    xlinkHref: "#9lp07qwvsb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#9lp07qwvsb"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#4072EE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.254.592c4.49 0 8.143 3.585 8.143 7.99 0 4.407-3.652 7.992-8.143 7.992-2.275 0-4.336-.92-5.815-2.403-.005.36-.176.714-.498.954-.24.179-.524.265-.806.265-.388 0-.772-.163-1.03-.476l-3.758-4.576c-.056-.07-.144-.114-.243-.114-.1 0-.187.045-.243.114l-3.759 4.576c-.257.312-.642.476-1.03.476-.281 0-.565-.086-.805-.265-.568-.424-.668-1.204-.222-1.744l4.246-5.166c.042-.05.07-.114.07-.184 0-.07-.027-.134-.07-.184l-1.869-2.265s-.031-.041-.043-.054l-.081.032v1.737c0 2.377-2.036 4.312-4.538 4.312-2.502 0-4.538-1.935-4.538-4.312V1.834c0-.686.585-1.242 1.308-1.242.721 0 1.306.556 1.306 1.242v5.543c0 1.007.863 1.827 1.924 1.827 1.06 0 1.924-.82 1.924-1.827V1.834c0-.53.353-1 .88-1.174.527-.172 1.112-.01 1.456.408l3.84 4.655c.057.069.145.113.243.113.1 0 .187-.044.244-.113l3.841-4.655c.445-.54 1.267-.634 1.836-.211.567.423.667 1.204.221 1.744l-4.329 5.246c-.043.05-.07.113-.07.184 0 .07.028.133.07.184h.001l2.813 3.424c-.399-.942-.619-1.974-.619-3.056 0-4.406 3.653-7.991 8.143-7.991zm46.444 0c.166 0 .301.09.301.199v15.583c0 .11-.135.2-.3.2-.167 0-.302-.09-.302-.2V.791c0-.11.135-.2.301-.2zM57.85 0c1.086 0 2.137.226 3.125.67.643.29.936 1.059.654 1.719-.282.66-1.031.96-1.674.67-.665-.299-1.373-.45-2.105-.45-2.891 0-5.244 2.414-5.244 5.382 0 2.7 1.976 4.967 4.522 5.331L65.852.688c.32-.464.895-.661 1.422-.489.527.172.885.675.885 1.243v13.117c0 .72-.569 1.304-1.27 1.304-.702 0-1.271-.584-1.271-1.304V5.68l-.084-.023-.036.054-6.713 9.72c-.244.354-.635.55-1.037.55l-.072-.001c-4.202-.095-7.612-3.667-7.612-7.989C50.064 3.585 53.556 0 57.849 0zm-9.172.592c.766 0 1.387.583 1.387 1.303s-.621 1.302-1.387 1.302h-2.29c-.155.008-.277.129-.276.276v10.644l-.01.13c-.078.643-.658 1.143-1.363 1.143-.752 0-1.362-.569-1.372-1.273h-.001V3.473c.001-.147-.12-.268-.275-.276h-1.387c-.16 0-.29.124-.29.275v10.645c-.012.704-.622 1.273-1.374 1.273-.752 0-1.362-.569-1.371-1.273h-.001V3.472c0-.151-.131-.275-.291-.275h-1.402c-.765 0-1.386-.583-1.386-1.302 0-.72.62-1.303 1.386-1.303zM1.3.592c.717 0 1.299.556 1.299 1.243V12.63c0 .167.142.303.316.303h5.453c.71 0 1.284.55 1.284 1.228 0 .68-.575 1.229-1.284 1.229H1.299c-.717 0-1.298-.557-1.298-1.243L0 1.835C0 1.148.582.592 1.299.592zm47.257 3.551c.833 0 1.508.591 1.508 1.32v8.607c0 .73-.675 1.32-1.508 1.32s-1.508-.59-1.508-1.32V5.463c0-.729.675-1.32 1.508-1.32zm-19.302-.942c-3.024 0-5.484 2.414-5.484 5.382 0 2.968 2.46 5.383 5.484 5.383s5.485-2.415 5.485-5.383S32.279 3.2 29.254 3.2z",
    transform: "translate(24 24)"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "AvenirLTPro-Light",
    fontSize: 18,
    fontWeight: 300,
    letterSpacing: -0.072,
    transform: "translate(24 24)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 80.64,
    y: 14
  }, "Store Visualizer")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementsDesktopBrand);
export default __webpack_public_path__ + "static/media/elements-desktop-brand.b7d4f0e979fac2f3fef6f21e5a39289e.svg";
export { ForwardRef as ReactComponent };